import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "vld-parent" }
const _hoisted_2 = { class: "w-lg-500px bg-white rounded shadow-sm p-10 p-lg-15 mx-auto" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "text-center mb-10" }, [
  /*#__PURE__*/_createElementVNode("img", {
    alt: "Logo",
    src: "/media/icons/superadmin/logocrm.svg",
    class: "h-40px mb-5"
  }),
  /*#__PURE__*/_createElementVNode("h1", { class: "text-dark mb-5" }, "Selamat Datang"),
  /*#__PURE__*/_createElementVNode("div", { class: "text-dark fs-4" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Silahkan Login Dengan Menggunakan Email dan Kata Sandi")
  ])
], -1)
const _hoisted_4 = { class: "fv-row mb-10" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fs-6 fw-bolder text-dark" }, "Email atau Nama Pengguna", -1)
const _hoisted_6 = { class: "fv-plugins-message-container" }
const _hoisted_7 = { class: "fv-help-block" }
const _hoisted_8 = { class: "fv-row mb-10" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex flex-stack mb-2" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, "Kata Sandi")
], -1)
const _hoisted_10 = { class: "input-group" }
const _hoisted_11 = { class: "input-group-prepend" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("  ")
const _hoisted_13 = { class: "fv-plugins-message-container" }
const _hoisted_14 = { class: "fv-help-block" }
const _hoisted_15 = { class: "d-flex flex-stack mt-2" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6 mb-0" }, null, -1)
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Lupa Kata Sandi ? ")
const _hoisted_18 = { class: "text-center" }
const _hoisted_19 = {
  type: "submit",
  ref: "submitButton",
  id: "kt_sign_in_submit",
  class: "btn btn-lg btn-primary w-100 mb-5"
}
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Masuk ", -1)
const _hoisted_21 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_22 = [
  _hoisted_20,
  _hoisted_21
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading = _resolveComponent("loading")!
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_loading, {
        active: _ctx.isLoading,
        "is-full-page": _ctx.fullPage,
        color: _ctx.isColor,
        "background-color": _ctx.isBackgroundColor,
        opacity: _ctx.isOpacity
      }, null, 8, ["active", "is-full-page", "color", "background-color", "opacity"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        class: "form w-100",
        id: "kt_login_signin_form",
        onSubmit: _ctx.onSubmitLogin,
        "validation-schema": _ctx.login
      }, {
        default: _withCtx(() => [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createVNode(_component_Field, {
              class: "form-control form-control-lg",
              type: "text",
              name: "username",
              placeholder: "Masukkan Email atau Nama Pengguna",
              autocomplete: "off"
            }),
            _createElementVNode("div", _hoisted_6, [
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_ErrorMessage, { name: "username" })
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("div", _hoisted_10, [
              (!_ctx.showPassword)
                ? (_openBlock(), _createBlock(_component_Field, {
                    key: 0,
                    class: "form-control form-control-lg",
                    type: "password",
                    name: "password",
                    placeholder: "Masukkan Kata Sandi",
                    autocomplete: "off"
                  }))
                : (_openBlock(), _createBlock(_component_Field, {
                    key: 1,
                    class: "form-control form-control-lg",
                    type: "text",
                    name: "password",
                    placeholder: "Masukkan Kata Sandi",
                    autocomplete: "off"
                  })),
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("span", {
                  style: {"height":"46px"},
                  class: "input-group-text",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.showPassWord && _ctx.showPassWord(...args)))
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(["fa", {
                  'fa-eye-slash': !_ctx.showPassword,
                  'fa-eye': _ctx.showPassword,
                }])
                  }, null, 2),
                  _hoisted_12
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createVNode(_component_ErrorMessage, { name: "password" })
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createVNode(_component_router_link, {
                to: "/password-reset",
                class: "link-primary fs-6 fw-bolder"
              }, {
                default: _withCtx(() => [
                  _hoisted_17
                ]),
                _: 1
              })
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", _hoisted_19, _hoisted_22, 512)
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ], 64))
}